import { render, staticRenderFns } from "./TreatSectionContent.vue?vue&type=template&id=05eb9593&scoped=true"
import script from "./TreatSectionContent.vue?vue&type=script&lang=js"
export * from "./TreatSectionContent.vue?vue&type=script&lang=js"
import style0 from "./TreatSectionContent.vue?vue&type=style&index=0&id=05eb9593&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eb9593",
  null
  
)

export default component.exports